import * as React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { ILoginForm } from './types';
import { validateEmail } from 'src/Utilities/Validations';
import whiteLineBg from '../../../Assets/whiteLineBg.png';
import KfLogo from '../../../Assets/kflogo.png';
const styles = (theme: any) => ({
    loginRoot: {
        minHeight: '100vh',
        width: '100vw',
        position: 'fixed' as 'fixed',
        top: '0px',
        // background: `url(${whiteLineBg}) center no-repeat fixed`,
        backgroundColor: '#010000',
        backgroundSize: 'cover',
    },
    overlay: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        overflow: 'auto',
        position: 'fixed' as 'fixed',
        top: '0px',
        width: '100%',
        height: '100%',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative' as 'relative',
        alignItems: 'center',
        height: '100%',
    },
    card: {
        top: '0',
        position: 'relative' as 'relative',
        background: '#242424',
        // boxShadow: '0px 3px 12px #707070',
        border: '1px solid #707070',
        borderRadius: '20px',
        padding: '45px 114px 20px',
        width: '660px',
        boxSizing: 'border-box',
        maxWidth: '100%',
        [theme.breakpoints.down('lg')]: {
            padding: '46px 72px 20px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px 20px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px 20px',
            width: '500px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '25px 25px',
            width: '100%',
            margin: '0px 20px 20px',
        },
        textAlign: 'center' as 'center',
    },
      logo: {
        marginBottom: '25px',
        width: '240px',
         [theme.breakpoints.down('sm')]: {
            width: '220px',
        },
          [theme.breakpoints.down('xs')]: {
           width: '180px',
        },
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 'bold',
        fontSize: '28px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        color: '#ffffff',   
        [theme.breakpoints.down('xs')]: {
            fontSize: '22px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 500,
        background: '#db2c29',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        color: 'white',
        fontSize: '16px',
        lineHeight: '18px',
        padding: '12px 12px',
        width: '182px',
        boxSize: 'borderBox',
        height: '48px',
        letterSpacing: '0.5px',
        boxShadow: 'none',
        marginTop: '12px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
            width: '180px',
            height: '40px',
            padding: '12px 8px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
        '&:hover': {
            backgroundColor: '#B3211E',
        },
    },
    errors: {
        border: '3px solid #db2c29',
    },
    message: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '16px',
        lineHeight: '18px',
        margin: '20px 0px 20px',
        color: '#ffffff',
        letterSpacing: '0.5px',
          [theme.breakpoints.down('xs')]: {
           fontSize: '15px',
           margin: '10px 0 0px',
        },
    },
    link: {
        color: '#db2c29',
        paddingLeft: '4px',
        textDecoration: 'none',
        letterSpacing: '0.5px',
        fontSize: '15px',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    resetPassword: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '16px',
        lineHeight: '18px',
        letterSpacing: '0.5px',
          [theme.breakpoints.down('xs')]: {
           fontSize: '15px',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '10px',
        '&:last-child': {
            marginBottom: '0px',
        },
          [theme.breakpoints.down('xs')]: {
            marginBottom: '6px',
        },
    },
    messageBox: {
        textAlign: 'center' as 'center',
        fontSize: '16px',
        lineHeight: '21px',
        marginTop: '12px',
        color: '#ffffff',
        width: '100%',
        padding: '0 25px 10px',
        boxSizing: 'border-box',
        [theme.breakpoints.down('lg')]: {
            padding: '0 70px 10px',
        },
         [theme.breakpoints.down('sm')]: {
            padding: '0',
        },
        [theme.breakpoints.down('xs')]: {
             fontSize: '15px',
            marginTop: '4px',
        },
    },

    labelField: {
        fontSize: '15px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 400,
        color: '#ffffff',
        letterSpacing: '0.5px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '15px',
        },
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid #ffffff',
        padding: '0 4px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        fontSize: '15px',
        letterSpacing: '0.7px',
        height: '38px',
        color: '#ffffff',
        caretColor: '#ffffff',
         [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid #db2c29',
        padding: '0 4px',
        height: '38px',
        marginTop: '4px',
        background: 'transparent',
        outline: 'none',
        color: '#ffffff',
        fontSize: '15px',
        letterSpacing: '0.7px',
         [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px',
    },
    erroSpan: {
        textAlign: 'left' as 'left',
        color: '#db2c29',
        fontSize: '12px',
        margin: '4px 0px 0px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '11px',
            margin: '2px 0px 0px',
        },
    },
    successSpan: {
        textAlign: 'left' as 'left',
        color: 'green',
        fontSize: '12px',
        margin: '4px 0px 0px',
    },
    footer: {
        marginTop: '50px',
        marginBottom: '15px',
        position: 'absolute' as 'absolute',
        bottom: '0px',
        left: '40%',
        right: '40%',
        color: '#ffffff',
        fontSize: '12px',
        [theme.breakpoints.down('md')]: {
            left: '40%',
            right: '40%',
        },
        [theme.breakpoints.down('sm')]: {
            left: '30%',
            right: '30%',
        },
        [theme.breakpoints.down('xs')]: {
            left: '20%',
            right: '20%',
        },
        fontSize: '12px',
        textAlign: 'center' as 'center',
    },
});

interface IProps {
    classes: any;
    onSubmit: (method: string) => void;
    form: ILoginForm;
    onChange: (
        form: 'login' | 'register',
        field: string
    ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    emailIsInvalid: (form: 'login' | 'register') => boolean;
    formIsDisabled: (form: 'login' | 'register') => boolean;
}

const statusList = [422, 409, 200, 404, 401]

export const resetPassword = (props: IProps) => {
    const { classes } = props;

    const errorSendingEmail = `There was an error sending your password reset email. Email info@keyframesports.com for help.`
    const [emailSent, setEmailSent]: any = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [error, setError]: any = React.useState();
    const [success, setSuccess]: any = React.useState();
    const [submitting, setSubmitting]: any = React.useState(false);

    React.useEffect(() => {
        const isInvalid = email.length > 0 && !validateEmail(email);
        setError(isInvalid);
    }, [email]);

    const sendEmail = async () => {
        const body = {
            email
        };
        const url = process.env.REACT_APP_ALEPH_URI +
            '/api-v1/authentication/password-reset/request';
        setSubmitting(true);
        const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        const status = await res.status;
        if (status === statusList[2]) {
            setSubmitting(false);
            setEmailSent(true);
            setSuccess('Reset link has been sent, please check your email.');
        } else {
            setSubmitting(false);
            setError(errorSendingEmail);
        }
    };

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };
    return (
        <div className={classes.loginRoot}>
            <div className={classes.overlay}>
                <div className={classes.content}>
                    <div className={classes.card}>
                        <img src={KfLogo} className={classes.logo} />
                        <div className={classes.heading}>RESET PASSWORD</div>
                        <div className={classes.messageBox}>
                            Enter your email address below and we'll email you a
                            link to reset your password
                        </div>
                        <form className={classes.formWrapper}>
                            <div className={classes.textField}>
                                <div className={classes.labelField}>Email*</div>
                                <input
                                    type='email'
                                    id='username'
                                    onChange={changeHandler}
                                    value={email}
                                    className={
                                        error
                                            ? classes.inputFieldError
                                            : classes.inputField
                                    }
                                    autoComplete='off'
                                    placeholder=''
                                    required={true}
                                ></input>
                                <span className={classes.erroSpan}>
                                    {error ? 'Incorrect email' : null}
                                </span>

                                <span className={classes.successSpan}>
                                    {success ? success : null}
                                </span>
                            </div>

                            <div className={classes.submitBtnWrapper}>
                                <Button
                                    disabled={error}
                                    variant='contained'
                                    color='primary'
                                    onClick={sendEmail}
                                    className={classes.submitBtn}
                                >
                                    Send link to email
                                </Button>
                            </div>

                            <div className={classes.message}>
                                <Link to='/login' className={classes.link}>
                                    Cancel
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={classes.footer}>© Keyframe Sports 2026</div>
        </div>
    );
};

export const ResetPassword = withStyles(styles)(resetPassword);
